import script from "./mergePdf.vue?vue&type=script&setup=true&lang=js"
export * from "./mergePdf.vue?vue&type=script&setup=true&lang=js"

import "./mergePdf.vue?vue&type=style&index=0&id=db4a2218&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db4a2218"]])

export default __exports__